var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrColoredIconFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4514_388)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0952 18.5925L9.0672 15.0392C8.99745 15.3896 8.84389 15.7327 8.55139 16.0252L4.00865 20.4409C3.59015 20.847 3.29821 21.302 3.14071 21.792C2.78578 22.8956 3.10753 23.9598 4.0469 24.7884C4.64202 25.3138 5.30127 25.581 5.97233 25.581C6.3582 25.581 6.74858 25.4921 7.1322 25.3138C7.59795 25.0972 8.01251 24.7502 8.3652 24.2844L12.175 19.232C12.4315 18.9024 12.7549 18.7061 13.0952 18.5925Z",
    fill: "#58B7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9031 2.30027C23.853 2.2547 18.8873 -2.23853 12.8528 1.45764C12.7538 1.51839 12.6582 1.58196 12.5643 1.65114C11.5371 2.41277 6.52247 6.52126 8.62846 12.6553C8.66559 12.7627 8.70834 12.8668 8.7539 12.9697C8.80565 13.0856 8.88102 13.2712 8.95021 13.5007L14.6359 18.5165C14.8716 18.5559 15.0651 18.6077 15.1861 18.6442C15.2946 18.6774 15.4032 18.7067 15.5146 18.7297C21.8686 20.0572 25.3139 14.5661 25.941 13.4529C25.9984 13.3517 26.0496 13.2487 26.098 13.1424C29.0112 6.69394 23.9352 2.3267 23.9031 2.30027Z",
    fill: "#58B7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.977 22.481C18.1249 21.7289 17.0274 21.3605 15.8827 21.4403C14.7437 21.5219 13.6963 22.0417 12.9352 22.904C12.1742 23.7668 11.7883 24.8699 11.8502 26.0112C11.9121 27.1559 12.4155 28.1999 13.2688 28.952C14.067 29.6562 15.0615 30.0016 16.0566 30.0016C17.2535 30.0016 18.4517 29.5021 19.3106 28.5284C20.8839 26.7447 20.7343 24.0318 18.977 22.481Z",
    fill: "#58B7CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4514_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrColoredIconFour);
export default __webpack_public_path__ + "static/media/ahr-colored-icon-four.95b3148e86c515afec1eece9ae9998a1.svg";
export { ForwardRef as ReactComponent };